import EndPointConfig from '../../models/api/EndPointConfig'

const controller = 'Configuration'

export const ConfigurationEP : EndPointConfig[] =[
        new EndPointConfig()
        .setMethod("GET")
        .setController(controller)
        .setActionName("GetAppClientConfiguration")
]